export const EVENT_TIME_UNAVAILABLE = 'Event time unavailable';

// Accept only the additive contract, never ambiguous legacy dates or epochs.
export function parseOrderEvent(instant) {
  if (typeof instant !== 'string' ||
      !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(instant)) return null;
  const date = new Date(instant);
  if (!Number.isFinite(date.getTime()) ||
      date.toISOString() !== instant.replace('Z', '.000Z')) return null;
  return date;
}

export function formatOrderEvent(instant, restaurantTimezone) {
  const date = parseOrderEvent(instant);
  if (!date) return EVENT_TIME_UNAVAILABLE;
  const options = {
    year: 'numeric', month: 'long', day: 'numeric',
    hour: 'numeric', minute: '2-digit', second: '2-digit',
    timeZoneName: 'short',
  };
  try {
    // Reject abbreviations and numeric offsets even if Intl accepts them.
    if (typeof restaurantTimezone !== 'string' ||
        (restaurantTimezone !== 'UTC' && !restaurantTimezone.includes('/'))) {
      throw new RangeError('Restaurant timezone unavailable');
    }
    return new Intl.DateTimeFormat('en-US', {
      ...options, timeZone: restaurantTimezone,
    }).format(date);
  } catch (error) {
    return `${new Intl.DateTimeFormat('en-US', {
      ...options, timeZone: 'UTC',
    }).format(date)} — UTC — restaurant timezone unavailable`;
  }
}